import React, { forwardRef } from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import "./Tabs.css";

export const Tabs = forwardRef(function Tabs(
  { variant = "underline", className = "", children, ...props },
  ref
) {
  return (
    <RadixTabs.Root ref={ref} className={`ui-tabs ui-tabs-${variant} ${className}`} {...props}>
      {children}
    </RadixTabs.Root>
  );
});

export const TabsList = forwardRef(function TabsList({ className = "", children, ...props }, ref) {
  return (
    <RadixTabs.List ref={ref} className={`ui-tabs-list ${className}`} {...props}>
      {children}
    </RadixTabs.List>
  );
});

export const TabsTrigger = forwardRef(function TabsTrigger(
  { className = "", children, ...props },
  ref
) {
  return (
    <RadixTabs.Trigger ref={ref} className={`ui-tabs-trigger ${className}`} {...props}>
      {children}
    </RadixTabs.Trigger>
  );
});

export const TabsContent = forwardRef(function TabsContent(
  { className = "", children, ...props },
  ref
) {
  return (
    <RadixTabs.Content ref={ref} className={`ui-tabs-content ${className}`} {...props}>
      {children}
    </RadixTabs.Content>
  );
});
